import { useGetSelectableApplicationsQuery } from '../../store/api/routesApi';
import type { SelectableApplicationsQueryArgs } from '../../types/physicalCargoSource';

export function useSelectableApplicationsQuery(
  args: SelectableApplicationsQueryArgs & { skip?: boolean }
) {
  const { skip, ...queryArgs } = args;
  return useGetSelectableApplicationsQuery(
    {
      context: queryArgs.context,
      search: queryArgs.search,
      limit: queryArgs.limit ?? 50,
      routeId: queryArgs.routeId,
      excludeRouteId: queryArgs.excludeRouteId
    },
    { skip: Boolean(skip) }
  );
}
